import { TextFilter } from "components/FilteredTable/filters";
import BooleanFilter from "components/FilteredTable/filters/BooleanFilter";
import { FilteredTableFilter } from "components/FilteredTable/types";


const filters: FilteredTableFilter[] = [
  {
    title: 'Пошук',
    key: 'search',
    component: TextFilter,
    filter: (value: string) => (
      value ? {
        search: value
      } : null
    ),
  },
  {
    title: '1-й рівень',
    key: 'level_1',
    component: BooleanFilter,
    filter: (value: boolean) => {
      return !!value ? { driver_request_settings__is_level_1: true } : null
    },
  },
  {
    title: 'Пошук водіїв',
    key: 'need_drivers',
    component: BooleanFilter,
    filter: (value: boolean) => {
      return !!value ? { driver_request_settings__is_need_drivers: true } : null
    },
  },
]

export default filters;